"use client";

import { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Avatar, AvatarFallback, AvatarImage } from "@kit/ui/avatar";

interface PostHeaderProps {
    username: string;
    location: string;
    onDataChange: (key: string, value: string) => void;
}

export default function PostHeader({ avatarUrl, username, location, onDataChange }: PostHeaderProps) {
    const [isEditingUsername, setIsEditingUsername] = useState(false);
    const [isEditingLocation, setIsEditingLocation] = useState(false);
    const [avatarSrc, setAvatarSrc] = useState(avatarUrl);

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        setAvatarSrc(URL.createObjectURL(file));
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { "image/*": [] },
        multiple: false,
    });

    return (
        <div className="flex items-center p-3">
            <div {...getRootProps()} className="relative cursor-pointer mr-2">
                <Avatar className="h-10 w-10">
                    <AvatarImage src={avatarSrc} alt={username} />
                    <AvatarFallback>{username.charAt(0)}</AvatarFallback>
                </Avatar>
                <input {...getInputProps()} />
                {isDragActive && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
                        <p className="text-white text-xs text-center">Drop</p>
                    </div>
                )}
            </div>
            <div className="flex flex-col justify-around">
                {isEditingUsername ? (
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => onDataChange("username", e.target.value)}
                        onBlur={() => setIsEditingUsername(false)}
                        autoFocus
                        className="font-semibold text-sm outline-none"
                    />
                ) : (
                    <span
                        className="font-semibold text-sm cursor-pointer outline-none"
                        onClick={() => setIsEditingUsername(true)}
                    >
                        {username}
                    </span>
                )}
                {isEditingLocation ? (
                    <input
                        type="text"
                        value={location}
                        onChange={(e) => onDataChange("location", e.target.value)}
                        onBlur={() => setIsEditingLocation(false)}
                        autoFocus
                        className="text-xs outline-none"
                    />
                ) : (
                    <span
                        className="text-xs cursor-pointer outline-none"
                        onClick={() => setIsEditingLocation(true)}
                    >
                        {location}
                    </span>
                )}
            </div>
        </div>
    );
}